import { atom } from 'recoil';

import { AssetsHierarchy } from '@pages/home-page/types';
import { Atoms } from '@store/constants';

export const assetsHierarchyAtom = atom({
  key: Atoms.assetsHierarchy,
  default: {} as AssetsHierarchy,
});
